<form class="modal-css">
  <div class="modal-header">
    <span class="modal-title"> Css config </span>
    <mat-icon (click)="closeModal(false)">close</mat-icon>
  </div>
  <div class="modal-body">
    <ngx-codejar
      [highlightMethod]="highlightMethodCss"
      [(code)]="css"
      class="code-editor"
      [showLineNumbers]="true"
    ></ngx-codejar>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn-cancel text-sm"
      data-bs-dismiss="modal"
      (click)="closeModal(false)"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn-save text-sm"
      data-bs-dismiss="modal"
      (click)="closeModal(true)"
    >
      Save
    </button>
  </div>
</form>
